import { RepliersListingLastStatus } from '../types/repliers/RepliersListingLastStatus';

export const WATCHED_NEIGHBOURHOOD_DEFAULT_SUBSCRIBED_STATUSES = [
  RepliersListingLastStatus.New,
  RepliersListingLastStatus.Sold,
];
